import ModalSuccess from "./modalSuccess";

export default ModalSuccess;
